export default {
  group: '用户组',
  role_group: '角色/用户组',
  no_create_group: '未创建用户组',
  download_template: '下载.csv模版',
  select_the_role_group: '请选择角色/用户组',
  del_clear_already_email_desc: '删除文件并清除已解析的邮箱',
  now_parse_email_desc:
    ' 正在解析邮箱地址（将自动合并相同的邮箱、过滤格式错误的地址）...',
  success_email_length_desc: '成功解析{{successLength}}个邮箱地址',
  err_email_length_desc: '{{errLength}}个地址错误',
  hide_invalid_email: '隐藏不合法邮箱',
  show_invalid_email: '展示不合法邮箱',
  file_parse_err_desc: '文件解析失败，请删除后重新上传',
  internet_error_file_err_desc: '网络断开，文件上传失败',
  email_valid_parse_desc: '不合法邮箱地址：',
  email_duplicate_parse_desc: '重复邮箱地址：',
  del_already_user: '删除已存在的成员',
  del_err_email: '删除错误邮箱',

  sure_remove_member_organization:
    '你是否确认从{{studioName}}({{studioID}})中移除成员"{{member}}？',

  input_many_email: '请输入新成员的邮箱地址（输入多个邮箱请按回车分隔）',
  upload_tips_desc: '您可以通过上传文件来邀请多位成员，请根据模板准备文件。',
  upload_click_desc: '拖动文件到此处，或者点击',
  upload: '上传',
  edit_member: '编辑成员',
  edit_fail: '编辑失败.',

  roles: '角色',
  groups: '用户组',
  please_select_the_role_group: '请选择角色/用户组',
  please_select_the_role: '请选择角色',
  approve_application: '同意申请',
  select: '请选择',
  select_role: '选择角色',
  token_has_copied: 'Secret Key已复制',
  expire_now: '立即过期',
  generate_token: '生成Key',
  access_token: 'Secret Key',
  the_token_will_expired_desc: 'Token将在该时间过期',
  select_game: '选择游戏',
  select_environment: '选择环境',
  role_and_scope: '角色 & 生效范围',
  add_role_and_scope: '添加角色 & 生效范围',
  basic: '基础信息',
  add_new_group: '创建新用户组',
  edit_group: '编辑用户组',
  view_group: '查看用户组',
  group_name: '用户组名',
  group_member: '用户组成员',
  enter_name_of_group: '输入用户组名称',
  select_member_of_group: '选择成员',
  enter_description: '输入该用户组描述',
  enter_the_role_description: '输入角色描述',
  access_rights: '分配权限',
  member: '成员',
  role: '角色',
  delete_role: '删除角色',
  delete_role_desc: '您是否确认删除该角色？',
  delete_role_Name_desc: '确定删除角色【{{roleName}}】吗?',
  delete_member_desc: '确定移除成员【{{member}}】吗？',
  search_group: '搜索用户组',
  delete_group: '删除用户组',
  delete_group_desc: '您是否确认删除该用户组？',
  permissions: '权限',
  search_role: '搜索角色',
  no_roles: '无角色',
  role_has_no_rights: '自定义角色无该权限',
  role_name: '角色名称',
  role_uppercase: '角色',
  add_new_role: '创建新角色',
  edit_role: '编辑角色',
  view_role: '查看角色',
  enter_name_of_role: '输入角色名称',
  please_enter_role_name: '请输入角色名称!',
  please_select_access_rights: '请选择分配权限!',
  please_select_members: '请选择成员',
  max_limit_emails_tags_20: '用户不得超过20个',
  no_permission_title: '权限限制',
  no_rbac_permission_action: '您没有该操作权限，请联系工作室管理员获取',
  no_support_rbac_permission_action: '您没有该操作权限',
  enter_group_name: '请输入用户组名称!',
  select_scope: '请选择生效范围!',
  scope: '生效范围',
  view_show_role: '角色',
  cannot_delete_group_desc_tips:
    '您当前无法删除该用户组，请先将成员移除后再继续该操作',
  cannot_delete_role_desc_tips:
    '您当前无法删除该角色，请先将成员移除后再继续该操作',
  related_group: '相关用户组',
  cannot_delete_custom_role_desc_tips:
    '您当前无法删除该角色，请先将其关联的用户组解绑后再继续该操作。',
  all_game: '全部游戏',
  all_env: '全部环境',
  view_all: '全部',
  permission_all: '全部权限',
  permission_none: '无权限',
  permission_part: '部分权限',
  no_page_permission_line_one: '抱歉，您没有访问此页面的权限。',
  no_page_permission_line_two: '请联系工作室管理员获取必要权限。',
  support_no_page_permission_line_one: '您暂无当前页面访问权限',
  support_no_page_permission_line_two: '如需使用请联系管理员授权',
  access_right_select_all: '全部选中',
  access_right_clean_all: '全部清除',
  access_right_select_game_tips: '请先选择游戏',
  access_right_delete_tips: '限制为至少一个角色 & 生效范围',
  access_right_system: '系统角色',
  access_right_system_group: '系统用户组',
  access_right_custom: '自定义',
  refuse: '拒绝',
  role_owner_desc:
    '具有平台最高权限，即拥有所有游戏的访问权限与最高操作权限，默认为游戏创建人，该角色身份可转移（工作室内唯一）。',
  role_admin_desc:
    '具有工作室的常规操作权限，拥有所有游戏的访问权限与最高操作权限。',
  role_editor_desc: '编辑者，具备所有服务的编辑权限。',
  role_viewer_desc: '查看者，仅具备浏览权限，不具备任何操作权限。',
  no_groups: '无用户组',
  per_studio: '工作室管理',
  per_service: '服务权限',
  per_organization: '组织管理',
  per_game: '游戏管理',
  per_env: '环境管理',
  per_expense: '费用中心',
  per_audit: '审计中心',
  per_api: '客户端API管控',
  per_audit_empty: '支持操作审计的服务均未开通，暂无数据',
  gourps_modified_tips: '系统定义，无法修改',
  groups_admin_desc:
    '管理员用户组，默认拥有所有游戏环境以及所属服务的最高权限，平台系统定义的用户组，仅支持添加成员。',
  groups_editor_desc:
    '编辑者用户组，默认拥有所有游戏环境以及所属服务的编辑权限，平台系统定义的用户组，仅支持添加成员。',
  groups_viewer_desc:
    '查看者用户组，默认拥有所有游戏环境以及所属服务的查看权限，平台系统定义的用户组，仅支持添加成员。',
  select_the_group: '请选择用户组',
  highest_selected: '已选择最高权限用户组',
  role_not_exist: '角色[{{roleName}}]已被删除, 请重新选择角色.',
  task_report: '任务记录',
  operation_report: '操作记录',
};
